export default "__VITE_ASSET__BLumVxUH__"